module.exports = __webpack_public_path__ + "static/gameoflife-6dfe4abc7c0d76c718f8dbd480ce2f92.png";